import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActions = ({ selectedCount, onStatusUpdate, onClearSelection }) => {
  const [selectedAction, setSelectedAction] = useState('');

  const actionOptions = [
    { value: '', label: 'Select action...' },
    { value: 'planned', label: 'Mark as Planned' },
    { value: 'in-progress', label: 'Mark as In Progress' },
    { value: 'installed', label: 'Mark as Installed' },
    { value: 'verified', label: 'Mark as Verified' },
    { value: 'expired', label: 'Mark as Expired' }
  ];

  const handleApplyAction = () => {
    if (selectedAction) {
      onStatusUpdate(selectedAction);
      setSelectedAction('');
    }
  };

  return (
    <div className="bg-primary/5 border-b border-primary/20 p-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Icon name="CheckSquare" size={20} className="text-primary" />
          <span className="font-medium text-foreground">
            {selectedCount} item{selectedCount !== 1 ? 's' : ''} selected
          </span>
        </div>
        
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <Select
              options={actionOptions}
              value={selectedAction}
              onChange={setSelectedAction}
              placeholder="Select action..."
              className="min-w-48"
            />
            
            <Button
              variant="default"
              size="sm"
              onClick={handleApplyAction}
              disabled={!selectedAction}
              className="whitespace-nowrap"
            >
              <Icon name="Play" size={16} />
              Apply
            </Button>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="text-muted-foreground hover:text-foreground"
          >
            <Icon name="X" size={16} />
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;